/**
 * Stats domain — play sessions and aggregated listening history.
 */
import { z } from "zod";
export const StatsPeriodSchema = z.enum(["1w", "1m", "3m", "6m", "1y", "ytd", "all"]);
/** Minimum seconds (or fraction of track) before a session counts as a play. */
export const MIN_LISTEN_SECONDS = 30;
export const MIN_LISTEN_FRACTION = 0.5;
/** Returns true if listened duration qualifies as a completed play for stats / lastPlayed. */
export function qualifiesAsPlay(listenedSeconds, durationSec) {
    const dur = durationSec ?? null;
    const threshold = dur != null && dur > 0
        ? Math.min(MIN_LISTEN_SECONDS, MIN_LISTEN_FRACTION * dur)
        : MIN_LISTEN_SECONDS;
    return listenedSeconds >= threshold;
}
export const PlayEntrySchema = z.object({
    trackId: z.number().int(),
    title: z.string().nullable(),
    artist: z.string().nullable(),
    owner: z.string().nullable(),
    playedAt: z.number().int(),
    listenedSeconds: z.number().int().nonnegative(),
    fullDurationSec: z.number().positive().nullable().optional(),
});
export const ActiveSessionSchema = z.object({
    trackId: z.number().int(),
    title: z.string().nullable(),
    artist: z.string().nullable(),
    owner: z.string().nullable(),
    startedAt: z.number().int(),
    durationSec: z.number().positive().nullable().optional(),
    lastReportedTime: z.number().nonnegative().optional(),
});
export const StatsFileSchema = z.object({
    version: z.literal(6).optional(),
    plays: z.array(PlayEntrySchema),
    activeSession: ActiveSessionSchema.nullable(),
});
//# sourceMappingURL=stats.js.map